/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CART_ACTIONS,
  USER_LOGIN_AUTH,
  USER_LOGOUT,
} from './globalActions'
import {
  userAddToCart,
  userInfor,
  userLogin,
  userRegister,
  userRemoveFromCart,
  userUpdateToCart,
} from '../../api/api'
import axiosBase from '../../services/axios-base'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch } from '../../store'
import { AxiosResponse } from 'axios'

export const checkRegisterUser = (registerForm: unknown) => async (dispatch: AppDispatch) => {
  try {
    const data = await userRegister(registerForm)

    localStorage.setItem('token', data.data)
    axiosBase.setToken(localStorage.token)

    dispatch({
      type: USER_LOGIN_AUTH,
      payload: {
        user: null,
        isAuthenticated: true,
        err: null,
      },
    })
    window.location.href = '/'
  } catch (error) {
    localStorage.removeItem('token')
    axiosBase.setToken()
    dispatch({
      type: USER_LOGIN_AUTH,
      payload: {
        user: null,
        isAuthenticated: false,
        err: error,
      },
    })
  }
}

export const checkLogoutUser = () => (dispatch: AppDispatch) => {
  axiosBase.setToken()
  localStorage.removeItem('token')
  dispatch({
    type: USER_LOGOUT,
    payload: { user: null, isAuthenticated: false, err: null },
  })
}
export const loginAPI = createAsyncThunk(
  'user/login',
  async (inforLogin: { email: string, password: string }) => {
    const response = await userLogin(inforLogin)
    return response.data
  }
)


export const getInforUserAPI = createAsyncThunk(
  'user/infor',
  async () => {
    axiosBase.setToken(localStorage.token)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = await userInfor()
    return response.data
  }
)

export const addToCartAPI = createAsyncThunk('user/addToCart', async (productID: string, thunkAPI) => {
  const { data } = await userAddToCart(productID)
  if (data.success) {
    thunkAPI.dispatch(getInforUserAPI())
  }
  return data
})

export const removeFromCartAPI = createAsyncThunk('user/removeFromCart', async (productID: string, thunkAPI) => {
  const response: AxiosResponse<{ success: boolean, message: any }> = await userRemoveFromCart(productID)
  if (response.data.success) {
    thunkAPI.dispatch(getInforUserAPI())
  }
  return response.data
})

export const checkUpdateToCart = (idpr: string, type: string) => async (dispatch: AppDispatch) => {
  try {
    const data = await userUpdateToCart(idpr, type)

    dispatch({
      type: CART_ACTIONS,
      payload: {
        user: data.data.message,
        isAuthenticated: true,
        err: data.data.text,
      },
    })
  } catch (error) {
    dispatch({
      type: CART_ACTIONS,
      payload: {
        user: error,
        isAuthenticated: true,
        err: error,
      },
    })
  }
}
